
import { StatusDisplayProps } from "./types";

export function StatusDisplay({ status }: StatusDisplayProps) {
  const statusMap: Record<string, { label: string; className: string }> = {
    completed: { 
      label: "Completed", 
      className: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100 rounded-sm" 
    },
    in_progress: { 
      label: "In Progress", 
      className: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100 rounded-sm" 
    },
    pending: {
      label: "Pending",
      className: "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200 rounded-sm"
    },
    shortlisted: {
      label: "Shortlisted",
      className: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100 rounded-sm"
    },
    hired: {
      label: "Hired",
      className: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100 rounded-sm"
    },
    rejected: {
      label: "Rejected",
      className: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100 rounded-sm"
    }
  };

  const display = statusMap[status] || { 
    label: status, 
    className: "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200 rounded-sm" 
  };

  return (
    <span className={`inline-flex rounded-sm px-2 py-1 text-xs font-semibold ${display.className}`}>
      {display.label}
    </span>
  );
}
